import $ from "jquery";
// window.$ = window.jquery = $;

import React, { useEffect, useState } from "react";
import { useLocation, } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Navbar from "./components/Navbar";
import MobileNav from "./components/MobileNav";
import { Outlet, ScrollRestoration, useHref } from "react-router-dom";

import packageJSON from '../../package.json'
import moment from "moment";

import Footer from "./components/Footer.jsx";

import Base from './utils/base'
import WAImage from "../assets/img/whitelogo-whatsapp-png-46043.png";

const Layout = (props) => {
	var base = new Base()
	const {t, i18n} = useTranslation()
  // const [lightBoxToggler, setLightBoxToggler] = useState(false);
	const location = useLocation()
	const [isShow, setIsShow] = useState(false)
	// const isShow = useSelector(isShow)

	const [phone, setPhone] = useState('')
	const [email, setEmail] = useState('')
	const [address, setAddress] = useState('')
	const [facebook, setFacebook] = useState('')
	const [tiktok, setTiktok] = useState('')
	const [instagram, setInstagram] = useState('')
	const [wa, setWa] = useState('')


  useEffect(() => {
		reload_new_version()
		get_info_data()
  }, []);

	useEffect(() => {
		if(!isShow)
			window.localStorage.setItem('isShow', isShow)
		// if(props.banner != null)
		// 	setBanner(props.banner)
	}, [isShow,])

	async function reload_new_version(){
		var last_version = await localStorage.getItem('version')
		try{
			if(last_version != null)
				last_version = JSON.parse(last_version)
			else
				last_version = {}
		} catch(e) {
			last_version = {}
		}

		if(last_version[location.pathname] == null || (last_version[location.pathname] != null && last_version[location.pathname] != packageJSON.version)){
			last_version[location.pathname] = packageJSON.version
			localStorage.setItem('version', JSON.stringify(last_version))
			// this.$forceUpdate()
			window.location.reload(true)
		}
	}

	async function get_info_data() {
		var response = await base.request(base.url_api + "/setting")

		if(response != null){
			if(response.status == "success"){
				for(let data of response.data){
					if(data.key == 'phone')
						setPhone(data.value)
					else if(data.key == 'address')
						setAddress(data.value)
					else if(data.key == 'email')
						setEmail(data.value)
					else if(data.key == 'facebook')
						setFacebook(data.value)
					else if(data.key == 'tiktok')
						setTiktok(data.value)
					else if(data.key == 'instagram')
						setInstagram(data.value)
					else if(data.key == 'wa_link')
						setWa(data.value)
				}
				
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

  return (
		<>
			{/* <div className="custom-cursor__cursor"></div>
			<div className="custom-cursor__cursor-two"></div> */}

			<div className="preloader">
				<div className="preloader__image" style={{ backgroundImage: "url(/assets/images/Mooz_Logo.png)", }}></div>
			</div>
			
			<div className="page-wrapper">
				<Navbar />
				<div className="position-relative">
					<Outlet context={[]}/>
				</div>
				<Footer />
			</div>

			<MobileNav/>
			
			<a href="#" data-target="html" className="scroll-to-target scroll-to-top" style={{ color: '#101D22', }}>
        <span className="scroll-to-top__text">{t('back_top')}</span>
        <span className="scroll-to-top__wrapper"><span className="scroll-to-top__inner"></span></span>
    	</a>

			<div class="position-fixed d-flex flex-column" style={{ right: '4rem', bottom: '3rem', gap: '1rem', zIndex: 101, }}>
				<a href={wa} target="__blank" class="btn btn-success rounded-circle d-flex align-items-center justify-content-center" style={{ aspectRatio: '1', width: '4rem', }}>
					<img src={WAImage} style={{ width: '2rem', }} alt="whatsapp link" />
				</a>

				<a href={instagram} target="__blank" class="btn text-white rounded-circle d-flex align-items-center justify-content-center" style={{ aspectRatio: '1', width: '4rem', backgroundColor: '#288AAC', }}>
					<svg xmlns="http://www.w3.org/2000/svg" style={{ height: '2rem', width: '2rem', }} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-instagram-icon lucide-instagram"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
				</a>
			</div>
  	</>
  );
};

export default Layout;
